/* Christmas PJs | unified cart drawer for custom AJAX add-to-cart flows.
   Native Shopify product-form submissions continue using the theme's CartDrawer. */
(() => {
  "use strict";

  const cartURL = () => window.routes?.cart_url || "/cart";

  function refreshHeader(cart) {
    if (!cart) return;
    document.querySelectorAll("[data-cp-cart-count]").forEach((node) => {
      node.textContent = String(cart.item_count || 0);
    });
    if (typeof cart.total_price === "number") {
      let total;
      try {
        total = new Intl.NumberFormat(document.documentElement.lang || "en-CA", {
          style: "currency", currency: cart.currency || "CAD"
        }).format(cart.total_price / 100);
      } catch (e) {
        total = (cart.total_price / 100).toFixed(2);
      }
      document.querySelectorAll("[data-cp-cart-total]").forEach((node) => {
        node.textContent = total;
      });
    }
  }

  async function refreshAndOpen(trigger) {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || typeof drawer.renderContents !== "function") {
      window.location.assign(cartURL());
      return;
    }
    const url = cartURL();
    const [sectionsResponse, cartResponse] = await Promise.all([
      fetch(url + (url.includes("?") ? "&" : "?") + "sections=cart-drawer,cart-icon-bubble", {
        credentials: "same-origin", headers: { "Accept": "application/json" }
      }),
      fetch(url + ".js", { credentials: "same-origin", headers: { "Accept": "application/json" } })
    ]);
    if (!sectionsResponse.ok) throw new Error("Unable to refresh cart drawer");
    const sections = await sectionsResponse.json();
    if (typeof sections?.["cart-drawer"] !== "string" || !sections["cart-drawer"].includes('id="CartDrawer"')) {
      throw new Error("Cart drawer HTML is unavailable");
    }
    let cart = null;
    if (cartResponse.ok) {
      cart = await cartResponse.json();
      drawer.classList.toggle("is-empty", Number(cart.item_count) === 0);
      refreshHeader(cart);
    }
    if (trigger && typeof drawer.setActiveElement === "function") drawer.setActiveElement(trigger);
    drawer.renderContents({ sections, id: cart?.items?.[0]?.id || null });
  }

  function openOrFallback(trigger) {
    refreshAndOpen(trigger).catch((error) => {
      console.warn("Christmas PJs cart drawer:", error);
      window.location.assign(cartURL());
    });
  }

  document.addEventListener("cp:cart-added", (event) => {
    openOrFallback(event.detail?.trigger || null);
  });

  // The published storefront uses a custom cinematic header, not Dawn's cart icon.
  document.addEventListener("click", (event) => {
    const link = event.target.closest?.(
      '.cp-cine-header__actions a[aria-label="View cart"], a.cp-cart-link'
    );
    if (!link || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        link.target === "_blank") return;
    event.preventDefault();
    openOrFallback(link);
  });
})();
